import { useOnline } from '../lib/appStatus';
import { Alert } from './Alert';

/** Shown in forms while there is no connection; the form keeps what was typed. */
export function OfflineNotice() {
  const online = useOnline();
  if (online) return null;
  return (
    <Alert kind="warning" title="Brak połączenia z internetem">
      Bez internetu nie da się zapisać zmian. Wpisane dane zostaną w formularzu – zapiszesz je, gdy wróci zasięg.
    </Alert>
  );
}
